import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListItems, getMixedListValues, nullDate, TDate } from '../../public/utility'
import { doGetSalaryInfo, doSaveSalaryInfo, doDeleteSalaryInfo } from '../../reducers/actions'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
class SetSalaryAdjustmentPersonDiv extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    componentDidMount = () => {
        this.doGetSalaryPerson(this.props.id)
    }

    doGetSalaryPerson = (id) => {
        Tyan.doPostEvent({
            event: 'GetSalaryPerson',
            data: { id },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        })
    }

    handlerSave = () => {
        const { onSave, onClose } = this.props
        const { id, changedValues基本信息 } = this.state
        Tyan.doPostEvent({
            event: 'SaveSalaryPerson',
            data: { id, changedValues基本信息 },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    onClose && onClose()
                    onSave && onSave()
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        return [
            { _checkbox: '调薪人员', minWidth: '95%', itemMinWidth: 180 },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth={'800'}
            controls={[
                { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
                { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
            ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), },
                ]
            }
        />
    }
}

export default connect()(SetSalaryAdjustmentPersonDiv)